import { EnvelopeIcon } from "@components/icons";
import Link from "next/link";
import { SecondaryButton } from "..";

export function EmailButton({ children, className, iconClassName = "size-4 stroke-2", iconColor = "currentcolor", ...props }) {
    return (
        <Link {...props}>
            <SecondaryButton className={`h-fit min-h-0 min-w-0 rounded-full !p-1 ${className}`}>
                <EnvelopeIcon className={iconClassName} color={iconColor} />
            </SecondaryButton>
        </Link>
    )
}

